import { Directive, Input, ElementRef, OnInit, signal, inject } from '@angular/core';

@Directive({
  selector: '[appCountUp]',
  standalone: true
})
export class CountUpDirective implements OnInit {
  private el = inject(ElementRef);

  @Input('appCountUp') targetValue = 0;
  @Input() duration = 2000; // ms

  private displayValue = signal(0);

  ngOnInit() {
    this.animate();
  }

  private animate() {
    const start = 0;
    const end = this.targetValue;
    const startTime = performance.now();

    const step = (currentTime: number) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / this.duration, 1);
      
      // Easing function: easeOutExpo (makes it feel "premium")
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      
      const currentCount = Math.floor(easeProgress * (end - start) + start);
      
      // Update the DOM directly for high performance
      this.el.nativeElement.innerText = currentCount.toLocaleString();

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  }
}